<template>
  <div class="customer-select-wrapper">
    <div class="flex gap-4 py-4 border-t-4 px-4 items-center">
      <i class="rounded-full flex-none h-min p-2.5 pi bg-gray-100 text-gray-500 pi pi-file"
         style="font-size: 0.85rem;" />
      <div class="flex flex-col justify-start items-start gap-1">
        <span class="font-medium">הערה פנימית</span>
        <span class="text-xs text-gray-500 ">{{ modelValue ?? 'הוספת הערה פנימית לתור, ההערה תופיע רק לכם.'}}</span>
      </div>
      <span class="flex justify-center items-center gap-1 font-medium text-sm w-28 flex-none mr-auto cursor-pointer" @click="containerClick">
        <i class="pi pi-plus" style="font-size: 0.85rem;" />
        <span class="underline">הוספת הערה</span>
      </span>
    </div>

  </div>
</template>

<script lang="ts" setup>
import { useDrawer } from '@torim-app/shared-components';
import AddAdminNoteContent from '@app/components/admin/components/AddAdminNoteContent.vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: false
  }
});

const emit = defineEmits(['nodeAdded']);
const { openDrawer, closeDrawer } = useDrawer();

const containerClick = () => {
  openDrawer(AddAdminNoteContent, {
    onNodeAdded: (text: string) => emit('nodeAdded', text),
    onClose: closeDrawer
  }, { title: 'הוספת הערה כללית', noPadding: true });
};

</script>

<style scoped>
.customer-select-wrapper {
  width: 100%;
}
</style>
